import { render } from "./dogGrooming.vue?vue&type=template&id=3c014f72"
import script from "./dogGrooming.vue?vue&type=script&lang=js"
export * from "./dogGrooming.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__